// extracted by mini-css-extract-plugin
export default {"fullHeight":"PT97Yy"};